// @erp/ui/home-figures — the figure strip inside a module's home tile.
//
// IN THE KIT, not in lib: three modules render this strip, and a module
// importing a helper from another module is the exact `module -> module` edge
// Fig 4.1 bans. AGENTS.md's rule for this case is explicit — a shared
// module-facing helper is PROMOTED here rather than duplicated or borrowed.
//
// The strip inside a module's home tile: a label over its number, two or
// three to a row. Deliberately NOT @erp/ui/stat-card — that is a page-level
// surface with its own card, padding and icon capsule, and three of them inside
// a tile is the nest of boxes the home was redesigned to stop drawing.
//
// Type: the label is Spectrum's Detail role (11px, the same key a definition
// list uses) and the value is 18px/700 — heading-size-xs, the smallest step
// that still reads as a figure rather than body copy.
import { For } from "solid-js";

export function HomeFigures(props: { items: { label: string; value: number | string }[] }) {
  return (
    <dl class="grid grid-cols-3 gap-2 rounded-field bg-base-200 px-3 py-2">
      <For each={props.items}>
        {(f) => (
          <div class="min-w-0">
            <dt class="text-detail-s truncate text-base-muted">{f.label}</dt>
            <dd class="truncate text-lg leading-tight font-bold text-base-content">{f.value}</dd>
          </div>
        )}
      </For>
    </dl>
  );
}
